import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import EmployeeContractTable from "./Components/EmployeeContractTable";
import "./index.css";
import AnalyticBox from "./Components/AnalyticBox";
import { getAnalyticData } from "@utils/data.js";
import { fetchAttendance } from "../../Redux/actions";
import { useSelector, useDispatch } from "react-redux";

function DashboardScreen() {
  const attendance = useSelector((state) => state.attendance.payload);
  const employees = useSelector((state) => state.employees.payload);
  const leaves = useSelector((state) => state.leaves.payload);
  const dispatch = useDispatch();

  useEffect(async () => {
    if (!attendance || !attendance.length > 0) {
      const currentDate = new Date().toISOString().slice(0, 7);
      dispatch(fetchAttendance({ month: currentDate }));
    }
  }, []);

  const analyticBoxes = getAnalyticData({ attendance, employees, leaves });
  return (
    <>
      <Grid container spacing={5} justifyContent="center">
        {analyticBoxes.map((box) => (
          <Grid item lg={6} key={box.title}>
            <AnalyticBox data={box} />
          </Grid>
        ))}
      </Grid>
      <div className="child-dashboard">
        <p className="heading">Employees Contract Expiring Soon</p>
        <EmployeeContractTable />
      </div>
    </>
  );
}

export default DashboardScreen;
